import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'archiveModalTitle'
	| 'archiveModalBodyLine1'
	| 'archiveModalBodyLine2'
	| 'archiveModalCancel'
	| 'archiveModalConfirm'
	| 'archiveErrorTitleSingle'
	| 'archiveErrorTitleBatch'
	| 'archiveErrorDescription'
	| 'archiveErrorGeneric';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		archiveModalTitle: {
			id: 'atlassian-team-update-archive.archive-modal-title',
			defaultMessage: '{teamCount, plural, one {Archive team?} other {Archive {teamCount} teams?}}',
			description:
				'Title for the confirmation modal. Shows "Archive team?" for a single team, or "Archive N teams?" for multiple.',
		},
		archiveModalBodyLine1: {
			id: 'atlassian-team-update-archive.archive-modal-body-line-1',
			defaultMessage:
				"Once archived, {teamCount, plural, one {this} other {these}} team's name, membership, and details can no longer be changed.",
			description:
				'First paragraph of the confirmation modal body explaining that archived teams cannot be modified. Uses "this" for single team and "these" for multiple.',
		},
		archiveModalBodyLine2: {
			id: 'atlassian-team-update-archive.archive-modal-body-line-2',
			defaultMessage:
				'{teamCount, plural, one {{teamName}} other {Archived teams}} will not appear in search, but any connections to work will remain.',
			description:
				'Second paragraph of the confirmation modal body explaining search visibility and work connections. Shows the team name for a single team, or "Archived teams" for multiple.',
		},
		archiveModalCancel: {
			id: 'atlassian-team-update-archive.archive-modal-cancel',
			defaultMessage: 'Cancel',
			description: 'Label for the cancel button in the archive teams confirmation modal.',
		},
		archiveModalConfirm: {
			id: 'atlassian-team-update-archive.archive-modal-confirm',
			defaultMessage: '{teamCount, plural, one {Archive} other {Archive all}}',
			description:
				'Label for the confirm button in the archive teams confirmation modal. Shows "Archive" for a single team, or "Archive all" for multiple.',
		},
		archiveErrorTitleSingle: {
			id: 'atlassian-team-update-archive.archive-error-title-single',
			defaultMessage: 'Failed to archive team',
			description: 'Title for the error flag shown when archiving a single team fails.',
		},
		archiveErrorTitleBatch: {
			id: 'atlassian-team-update-archive.archive-error-title-batch',
			defaultMessage: 'Failed to archive teams',
			description: 'Title for the error flag shown when archiving multiple teams fails.',
		},
		archiveErrorDescription: {
			id: 'atlassian-team-update-archive.archive-error-description',
			defaultMessage: 'Something went wrong. Please try again.',
			description: 'Description text for the error flag shown when archiving teams fails.',
		},
		archiveErrorGeneric: {
			id: 'atlassian-team-update-archive.archive-error-generic',
			defaultMessage: 'Failed to archive team',
			description: 'Generic error message for team archival failures.',
		},
	});

export default message;
